import React from 'react'
import FirebaseContext from "../../firebase/context";
import CompCicloListEdit from './CompCicloListEdit';

import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button } from '@material-ui/core';


const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
});

const CompAdminUsuario = (props) => {
    const classes = useStyles();
    const { firebase, user } = React.useContext(FirebaseContext);
    const [showCicloFormEdit, setShowCicloFormEdit] = React.useState(false);

    const editUsuario = rol => {
            const editUsuario = {...props.usuario}           
            editUsuario.rol = rol         
            firebase.db.collection("colUsuarios").doc(props.usuario.id).set(editUsuario, {merge: true});          
            props.setAlumnoUpdate(true)
    }

    // const eliminarCiclo = id => {
    //     firebase.db
    //         .collection("colCiclos")
    //         .doc(id)
    //         .delete()
    //         .then(success => {
    //             setCicloSelect(idCiclo);
    //         });
    // };



    return (
        <React.Fragment key={props.index}>
            <TableRow
                hover
                role="checkbox"
            >
                <TableCell component="th" scope="row">{props.usuario.nombre}</TableCell>
                <TableCell align="right">{props.usuario.email}</TableCell>
                <TableCell align="right">{props.usuario.rol}</TableCell>
                <TableCell align="right">
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.button}
                        // startIcon={<DeleteIcon />}
                    onClick={() => editUsuario(0)}
                    >
                        Visitante
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        // startIcon={<DeleteIcon />}
                        onClick={() => editUsuario(2)}
                    >
                        Postulante
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.button}
                        // startIcon={<DeleteIcon />}
                        onClick={() => editUsuario(3)}
                    >
                        Alumno
                    </Button>
                </TableCell>

            </TableRow>


        </React.Fragment>
    )
}

export default CompAdminUsuario
